export default {
  modalTitle: 'Resize component',
  widthLabel: 'Width',
  widthPlaceholder: 'Default',
  heightLabel: 'Height',
  heightPlaceholder: 'Default',
  widthSize: {
    SMALL: '2 Columns',
    MID: '3 Columns',
    LARGE: '4 Columns',
    COL5: '5 Columns',
    XLARGE: '6 Columns',
    COL7: '7 Columns',
    COL8: '8 Columns',
    COL9: '9 Columns',
    COL10: '10 Columns',
    COL11: '11 Columns',
    COL12: '12 Columns',
  },
  heightSize: {
    SMALL: 'Small',
    MID: 'Medium',
    LARGE: 'Large',
    XLARGE: 'Extra Large',
  },
};
